module.exports = __webpack_public_path__ + "media/img/frontend_application/Bannermobile-0d68cc589037bfe67798b0ec22414790.png";